/** @format */

export const SET_KNOWN_ACTIVITY_VALUES = "SET_KNOWN_ACTIVITY_VALUES";
export const SET_KNOWN_CREATE_INVENTORY_VALUES =
  "SET_KNOWN_CREATE_INVENTORY_VALUES";
export const SHOW_MODAL_TOGGLE = "SHOW_MODAL_TOGGLE";
